import { useEffect, useState } from 'react';
import AdminOnlyWrapper from 'ui-addon-upgrades/_core/common/components/AdminOnlyWrapper';
import { REQUEST_TRIAL } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { debounce } from '../../../utils';
import { getConflictingTrial, hasTrialedSameUpgradeProduct } from '../utils';
import TrialActivationButtonWithTooltip from './TrialActivationButtonWithTooltip';
import TrialActivationModalContainer from './TrialActivationModalContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CLICK_DELAY = 50;
function sequence(...handlers) {
  return (...args) => {
    handlers.forEach(handler => handler && handler(...args));
  };
}
const TrialActivationButton = props => {
  const [showActivationModalContainer, setShowActivationModalContainer] = useState(false);
  const {
    activeTrials,
    expiredTrials,
    isMultiTrial,
    upgradeData,
    level,
    isUpgradePoint,
    onClick = () => {},
    onSuccess,
    shouldHideSurvey,
    children,
    isLoadingTrackingProps,
    use = 'primary',
    block,
    dataSeleniumId
  } = props;
  const handleClick = () => {
    tracker.track('trialActivationButtonInteraction', Object.assign({
      action: 'clicked'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      isMultiTrial,
      activeTrials,
      expiredTrials,
      trialId: upgradeData.trialId,
      duration: upgradeData.duration
    }));
    if (isUpgradePoint) {
      tracker.track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, getUpgradeDataTrackingProperties(upgradeData)));
      tracker.track('interaction', Object.assign({
        action: 'clicked trial activation',
        isPrimaryCta: level === 1,
        isSecondaryCta: level === 2
      }, getUpgradeDataTrackingProperties(upgradeData)));
    }
    setShowActivationModalContainer(true);
  };
  const debouncedHandleClick = debounce(handleClick, CLICK_DELAY);
  useEffect(() => {
    tracker.track('trialActivationButtonInteraction', Object.assign({
      action: 'viewed'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      isMultiTrial,
      activeTrials,
      expiredTrials,
      trialId: upgradeData.trialId,
      duration: upgradeData.duration
    }));
    if (isUpgradePoint) {
      tracker.track('interaction', Object.assign({
        action: 'viewed trial activation',
        isPrimaryCta: level === 1,
        isSecondaryCta: level === 2
      }, getUpgradeDataTrackingProperties(upgradeData)));
    }
    return () => {
      debouncedHandleClick.reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const trialI18nKey = upgradeData.apiName ? `upgrades.trialActivationButton.${upgradeData.apiName}` : `upgrades.trialActivationButton.${upgradeData.upgradeProduct}`;
  const trialedProducts = [...(activeTrials || []), ...(expiredTrials || [])];
  const isTrialed = !!(trialedProducts.length && hasTrialedSameUpgradeProduct(trialedProducts, upgradeData.upgradeProduct));

  // If `isTrialed` we have a 1:1 match with a product that the user has already trialed so we don't need to search for conflicts in other upgradeProducts
  const conflictingTrial = !isTrialed && activeTrials ? getConflictingTrial(activeTrials, upgradeData.upgradeProduct) : undefined;
  const onClickSequence = sequence(debouncedHandleClick, onClick);
  if (!upgradeData.trialId) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showActivationModalContainer && /*#__PURE__*/_jsx(TrialActivationModalContainer, {
      activeTrials: activeTrials,
      expiredTrials: expiredTrials,
      isMultiTrial: isMultiTrial,
      upgradeData: upgradeData,
      shouldHideSurvey: shouldHideSurvey,
      onSuccess: onSuccess
    }), /*#__PURE__*/_jsx(AdminOnlyWrapper, {
      upgradeData: upgradeData,
      adminType: TEAM,
      modalType: REQUEST_TRIAL,
      children: /*#__PURE__*/_jsx(TrialActivationButtonWithTooltip, {
        upgradeProduct: upgradeData.upgradeProduct,
        onClick: onClickSequence,
        isTrialed: isTrialed,
        isLoading: !!isLoadingTrackingProps,
        trialI18nKey: trialI18nKey,
        showActivationModalContainer: showActivationModalContainer,
        use: use,
        conflictingTrial: conflictingTrial,
        block: block,
        dataSeleniumId: dataSeleniumId,
        children: children
      })
    })]
  });
};
export default TrialActivationButton;